import { z } from 'zod';
export const SocialOpportunitiesUpdateActionSchema = z.object({
    updates: z
        .array(z.object({
        path: z.string().describe(`
          JSONPath expression to update.
          
          Example:
          {
            updates = [
              {"path": "$.title", "value": "New Title"},
              {"path": "$.items[2].status", "value": "completed"}
            ]
          }`),
        // THIS SHOULD BE Z.UNKNOWN, BUT NOT SUPPORTED WITH KURT
        value: z.string().describe('The new value to set at the specified path'),
    }))
        .describe('List of update operations'),
});
export const SocialOpportunitiesRemoveActionSchema = z.object({
    itemsToRemove: z
        .array(z.object({
        path: z.string().describe(`
        JSONPath expression to remove from. Each operation contains:
        - path: JSONPath expression targeting the specific element(s) to remove
                  (e.g., "$.items[2]", "$.items[?(@.id == 'abc')]")
  
        Starting the path with "$.items" is very important.
          
        Example:
        {
          itemsToRemove = [
              {"path": "$.items[0]"},  # Remove first item
          ]
        }`),
    }))
        .describe('List of removal operations'),
});
